import { Carousel } from "antd";
import { Col, Row } from "antd";
import { useRef } from "react";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { useBrands } from "../../../Hooks/useProductsBySubCategory";
import styles from "../LandingV2.module.scss";

export const PopularBrandsSlider = () => {
  const brandsRef = useRef(null);
  const navigate = useNavigate();
  const { brands: popularBrands } = useBrands();

  return (
    <div className={styles.brands_slider + " container"}>
      <div className={"see_more_title"}>
        <h2>Popular Brands</h2>
      </div>
      <Row gutter={[10, 10]}>
        <Col lg={1} xs={0}>
          <div
            role="button"
            onClick={() => brandsRef.current.prev()}
            className="d-flex justify-content-start align-items-center h-100"
          >
            <BsArrowLeft size={25} />
          </div>
        </Col>
        <Col lg={22} xs={24}>
          <Carousel
            ref={brandsRef}
            autoplay
            dots={false}
            draggable={true}
            slidesToShow={6}
            slidesToScroll={2}
            responsive={[
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 6,
                  slidesToScroll: 6,
                },
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4,
                },
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                },
              },
            ]}
          >
            {popularBrands.map((item, index) => (
              <div
                className="d-flex justify-content-center px-3 px-sm-5 cursor-pointer"
                key={index}
                onClick={() => {
                  navigate(`/brand/${item.slug}_${item.id}`);
                }}
              >
                <img
                  src={item.image}
                  alt="brand_logo"
                  loading="lazy"
                  className="img-fluid"
                />
              </div>
            ))}
          </Carousel>
        </Col>
        <Col lg={1} xs={0}>
          <div
            className="d-flex justify-content-end align-items-center h-100"
            role="button"
            onClick={() => brandsRef.current.next()}
          >
            <BsArrowRight size={25} />
          </div>
        </Col>
      </Row>
    </div>
  );
};
